import React, { useState } from "react";
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PreviewCertificate from "./PreviewCertificate";
import { Helmet } from "react-helmet";
import StudentDrawer from "./StudentDrawer";
import FeeCertificatePNG from "assets/media/images/certificate-Images/FeeCertificate.png";
import TeacherCertificatePNG from "assets/media/images/certificate-Images/Teacher Experience Certificate.png";
import CharacterCertificatePNG from "assets/media/images/certificate-Images/Character Certificate.png";
import ParticipationCertificatePNG from "assets/media/images/certificate-Images/Participation Certificate.png";
import SchoolLeavingCertificatePNG from "assets/media/images/certificate-Images/School Leaving Certificate.png";
import DOBCertificatePNG from "assets/media/images/certificate-Images/Date of Birth Certificate.png";
import ExcellenceCertificatePNG from "assets/media/images/certificate-Images/ExellenceCertificate.png";
import BonafideCertificatePNG from "assets/media/images/certificate-Images/BonafiedCertificate.png";
// import FeeCertificatePNG from "../../../../../assets/media/images/certificate-Images/FeeCertificate.png";
// import TeacherCertificatePNG from "../../../../../assets/media/images/certificate-Images/Teacher Experience Certificate.png";
// import CharacterCertificatePNG from "../../../../../assets/media/images/certificate-Images/Character Certificate.png";
// import ParticipationCertificatePNG from "../../../../../assets/media/images/certificate-Images/Participation Certificate.png";
// import SchoolLeavingCertificatePNG from "../../../../../assets/media/images/certificate-Images/School Leaving Certificate.png";
// import DOBCertificatePNG from "../../../../../assets/media/images/certificate-Images/Date of Birth Certificate.png";
// import ExcellenceCertificatePNG from "../../../../../assets/media/images/certificate-Images/ExellenceCertificate.png";
// import BonafideCertificatePNG from "../../../../../assets/media/images/certificate-Images/BonafiedCertificate.png";
import StaffDrawer from "./StaffDrawer";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import Transition from "./components/utils/Transition";
import YouTubeFloating from "app/components/common/floatingButton/YouTubeFloating";
import { StudentManagementMiscCertificatelinks } from "app/utils/youTubeLink";
import { DatePicker } from "@mui/x-date-pickers";

const certificateNameList = [
  {
    _id: 1,
    imageURL: FeeCertificatePNG,
    name: "Fee Certificate",
  },
  {
    _id: 2,
    imageURL: CharacterCertificatePNG,
    name: "Character Certificate",
  },
  {
    _id: 3,
    imageURL: SchoolLeavingCertificatePNG,
    name: "School Leaving Certificate",
  },
  {
    _id: 4,
    imageURL: TeacherCertificatePNG,
    name: "Teacher Experience Certificate",
  },
  {
    _id: 5,
    imageURL: DOBCertificatePNG,
    name: "Birth Certificate",
  },
  {
    _id: 6,
    imageURL: ParticipationCertificatePNG,
    name: "Participation Certificate",
  },
  {
    _id: 7,
    imageURL: BonafideCertificatePNG,
    name: "Bonafide Certificate",
  },
  {
    _id: 8,
    imageURL: ExcellenceCertificatePNG,
    name: "Excellence Certificate",
  },
];

const Certificate = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [show, setShow] = useState(false);
  const [showStaff, setShowStaff] = useState(false);
  const [showParticipation, setShowParticipation] = useState(false);
  const [showExcellence, setShowExcellence] = useState(false);
  const [showLeavingDate, setShowLeavingDate] = useState(false);

  const [participationData, setParticipationData] = useState({
    eventName: "",
    durationOfWorkShop: 0,
    eventDate: "",
    eventDetails: "",
  });
  const [excellenceData, setExcellenceData] = useState({
    excellenceField: "",
  });
  const [leavingDate, setLeavingDate] = useState("");

  const [state, setState] = useState({
    certificateNameList: certificateNameList,
    viewData: {},
    viewDialog: false,
    previewDialog: false,
    certificateName: "",
  });

  const handleProceed = () => {
    setState((prev) => ({
      ...prev,
      previewDialog: false,
    }));

    if (state.certificateName === "Teacher Experience Certificate") {
      setShowLeavingDate(true);
    } else if (state.certificateName === "Participation Certificate") {
      setShowParticipation(true);
    } else if (state.certificateName === "Excellence Certificate") {
      setShowExcellence(true);
    } else {
      setShow(true);
    }
  };

  return (
    <>
      <StudentDrawer
        setShow={setShow}
        show={show}
        certificateName={state.certificateName}
        participationData={participationData}
        excellenceData={excellenceData}
      />

      <StaffDrawer
        setShowStaff={setShowStaff}
        showStaff={showStaff}
        certificateName={state.certificateName}
        leavingDate={leavingDate}
      />

      {/* event dialog for proceding */}
      <Dialog
        open={showParticipation}
        TransitionComponent={Transition}
        onClose={() => setShowParticipation(false)}
        PaperProps={{
          sx: { minWidth: isMobile ? "90vw" : "50%" },
        }}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextFieldLabel title="Event Name" />
              <CustomTextField
                name="eventName"
                fullWidth
                value={participationData.eventName}
                onChange={(e) =>
                  setParticipationData((prev) => ({
                    ...prev,
                    eventName: e.target.value,
                  }))
                }
                placeholder="Event Name"
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldLabel title="Duration Of WorkShop" />
              <CustomTextField
                name="WorkShopName"
                fullWidth
                value={participationData?.durationOfWorkShop}
                onChange={(e) =>
                  setParticipationData((prev) => ({
                    ...prev,
                    durationOfWorkShop: e.target.value,
                  }))
                }
                placeholder="Duration Of WorkShop (in days)"
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldLabel title="Event WorkShop Name" />
              <CustomTextField
                name="WorkShopName"
                fullWidth
                value={participationData?.eventDetails}
                onChange={(e) =>
                  setParticipationData((prev) => ({
                    ...prev,
                    eventDetails: e.target.value,
                  }))
                }
                placeholder="Event WorkShop Name"
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldLabel title="Event Date" />
              <CustomTextField
                name="eventDate"
                fullWidth
                type="date"
                value={participationData?.eventDate}
                onChange={(e) =>
                  setParticipationData((prev) => ({
                    ...prev,
                    eventDate: e.target.value,
                  }))
                }
                placeholder="Event Date"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={
              !participationData.eventName ||
              !participationData.durationOfWorkShop ||
              !participationData.eventDetails ||
              !participationData.eventDate
            }
            sx={{ textTransform: "capitalize" }}
            onClick={() => {
              setShowParticipation(false);
              setShow(true);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      {/* Excellence dialog for proceding */}
      <Dialog
        open={showExcellence}
        TransitionComponent={Transition}
        onClose={() => setShowExcellence(false)}
        PaperProps={{
          sx: { minWidth: isMobile ? "90vw" : "50%" },
        }}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextFieldLabel title="Excellence Field" />
              <CustomTextField
                name="excellenceField"
                fullWidth
                value={excellenceData.excellenceField}
                onChange={(e) =>
                  setExcellenceData((prev) => ({
                    ...prev,
                    excellenceField: e.target.value,
                  }))
                }
                placeholder="Excellence Field"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={!excellenceData.excellenceField}
            sx={{ textTransform: "capitalize" }}
            onClick={() => {
              setShowExcellence(false);
              setShow(true);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      {/* Leaving Date dialog for proceding Teacher Experience certificate */}
      <Dialog
        open={showLeavingDate}
        TransitionComponent={Transition}
        onClose={() => setShowLeavingDate(false)}
        PaperProps={{
          sx: { minWidth: isMobile ? "90vw" : "40%" },
        }}
      >
        <DialogContent>
          <Grid item xs={12}>
            <TextFieldLabel title="Leaving Date" />
            
            <DatePicker
              name="leavingDate"
              fullWidth
              value={leavingDate}
              onChange={(date) => setLeavingDate(date)}
              inputFormat="DD-MM-YYYY"
              renderInput={(params) => <CustomTextField {...params} />}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={!leavingDate}
            sx={{ textTransform: "capitalize" }}
            onClick={() => {
              setShowLeavingDate(false);
              setShowStaff(true);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <YouTubeFloating videoLink={StudentManagementMiscCertificatelinks} />
      {/* view dialog */}
      <Dialog
        open={state.previewDialog}
        TransitionComponent={Transition}
        PaperProps={{
          sx: { minWidth: isMobile ? "90vw" : "90%" },
        }}
        onClose={() => setState((prev) => ({ ...prev, previewDialog: false }))}
      >
        <PreviewCertificate
          state={state}
          setState={setState}
          handleProceed={handleProceed}
          certificateName={state.certificateName}
        />
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            size="large"
            sx={{ textTransform: "capitalize" }}
            onClick={() =>
              setState((prev) => ({ ...prev, previewDialog: false }))
            }
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Helmet>
        <title>Certificates</title>
      </Helmet>
      {/* mapping the certificate name */}
      <Stack
        direction="row"
        gap={2}
        flexWrap="wrap"
        sx={{ mt: 2, mb: 2, px: 2 }}
        justifyContent={{ xs: "center", md: "flex-start" }}
      >
        {state.certificateNameList?.map((value, index) => (
          <ShowImage key={value?._id}>
            <img src={value?.imageURL} alt="ekalsutra-folder" />
            <Stack
              className="folder_image__box"
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <ViewButtonWrap
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    previewDialog: true,
                    certificateName: value?.name,
                  }))
                }
              >
                <RemoveRedEyeIcon sx={{ color: "#0B4977", fontSize: "25px" }} />
              </ViewButtonWrap>
            </Stack>
            <Typography variant="h6" sx={{ mt: 1, textAlign: "center" }}>
              {value?.name}
            </Typography>
          </ShowImage>
        ))}
      </Stack>
    </>
  );
};

export default Certificate;

const ShowImage = styled(Box)`
  width: 200px;
  height: 182px;
  position: relative;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  margin: 0 10px 20px 8px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 10px;
  }
  .folder_image__box {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(8, 76, 132, 0.75);
    border-radius: 10px;
    display: none;
    transition: all 0.3s;
    z-index: 3;
  }
  :hover .folder_image__box {
    display: flex;
    transition: all 0.3s;
  }
`;

const ViewButtonWrap = styled(Box)`
  height: 36px;
  width: 36px;
  background: #ebf0f4;
  border-radius: 10.2857px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
